import React, { useState } from "react";
import ModalHeader from "../../../components/ui/ModalHeader";
import PlanOverView from "./PlanOverView";
import DaysTab from "../../../components/common/DaysTab";
import AddNewWorkOut from "./AddNewWorkOut";
import WeeksTab from "../../../components/common/WeeksTab";

const AllPlanModal = ({
  jsonData,
  onClose,
  onSubmit,
  selectedPlanId,
  setSelectedImageUrl,
  setSelectedVideoUrl,
  setUploadedJson,
  imageUrl,
  videoUrl

}) => {
  const [activeTab, setActiveTab] = useState("home-tab");
  const [activeDay, setActiveDay] = useState("inner-1");

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    if (tabId.startsWith("week")) {
      setActiveDay("inner-1");
    }
  };

  const handleDayChange = (dayId) => {
    setActiveDay(dayId);
  };

  const { weeks } = jsonData || {};

  if (!weeks) {
    return null;
  }

  return (
    <>
      <div
        className="modal fade show"
        id="exampleAllPlanModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel3"
        aria-hidden="true"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <ModalHeader onClose={onClose} />
            <div className="modal-body">
              <div className="row">
                <WeeksTab
                  activeTab={activeTab}
                  onTabChange={handleTabChange}
                  weeks={weeks}
                />
                <div className="col-sm-10">
                  <div className="tab-content" id="myTabContent">
                    <div
                      className={`tab-pane fade ${
                        activeTab === "home-tab" ? "show active" : ""
                      }`}
                      id="home-tab-pane"
                      role="tabpanel"
                      aria-labelledby="home-tab"
                      tabIndex="0"
                    >
                      <PlanOverView
                        setUploadedJson={setUploadedJson}
                        jsonData={jsonData}
                        setSelectedImageUrl={setSelectedImageUrl}
                        setSelectedVideoUrl={setSelectedVideoUrl}
                        imageUrl={imageUrl}
                        videoUrl={videoUrl}
                        disabled={true}
                      />
                    </div>

                    {weeks.map((week, weekIndex) => (
                      <div
                        key={`week-${weekIndex}`}
                        className={`tab-pane fade ${
                          activeTab === `week-${weekIndex + 1}-tab`
                            ? "show active"
                            : ""
                        }`}
                        id={`week-${weekIndex + 1}-tab-pane`}
                        role="tabpanel"
                        aria-labelledby={`week-${weekIndex + 1}-tab`}
                        tabIndex="0"
                      >
                        <h2>{`WEEK ${weekIndex + 1}`}</h2>
                         <DaysTab
                          activeDay={activeDay}
                          onDayChange={handleDayChange}
                        />
                        <div className="tab-content">
                          {week.days?.map((day, dayIndex) => (
                            <div
                              key={`inner-${dayIndex + 1}`}
                              className={`tab-pane fade ${
                                activeDay === `inner-${dayIndex + 1}`
                                  ? "show active"
                                  : ""
                              }`}
                              id={`inner-${dayIndex + 1}`}
                              role="tabpanel"
                              aria-labelledby={`inner-${dayIndex + 1}-tab`}
                            >
                              <AddNewWorkOut
                                weekIndex={weekIndex}
                                dayIndex={dayIndex}
                                excerciseData={day}
                                setUploadedJson={setUploadedJson}
                                setSelectedImageUrl={setSelectedImageUrl}
                                setSelectedVideoUrl={setSelectedVideoUrl}
                                disabled={true}
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            {!selectedPlanId ? (
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onSubmit}
                >
                  Save & Next
                </button>
              </div>
            ) : (

              <div className="modal-footer">
                 <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onSubmit}
                >
                  Save 
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onClose}
                >
                  Close
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default AllPlanModal;
